
$(() => {
  const unslider = $('.testimonial-slider-2 .unslider');
  const unsiderLi = unslider.find('.unslider-wrap li');
  const unsliderArrow = unslider.find('.unslider-arrow');

  if (unslider.length == 0) {
    return;
  }

  function addRemoveArrows() {
    const firstLi = unsiderLi.first();
    const lastLi = unsiderLi.last();

    if (firstLi.hasClass('unslider-active')) {
      unslider.find('.unslider-arrow.prev').addClass('disabled');
      unslider.find('.unslider-arrow.next').removeClass('disabled');
    } 
    else if (lastLi.hasClass('unslider-active')) {
      unslider.find('.unslider-arrow.next').addClass('disabled');
      unslider.find('.unslider-arrow.prev').removeClass('disabled');
    }
    else{
      unslider.find('.unslider-arrow').removeClass('disabled');
    }
  }
  unsliderArrow.on('click', () => {
    setTimeout(addRemoveArrows, 300);
  });
  unslider.on('unslider.change', () => {
    addRemoveArrows();
  });
  $(window).on('load', () => {
    addRemoveArrows();
  });
});
